import { render } from "./Cash.vue?vue&type=template&id=131e5bf4&scoped=true&ts=true"
import script from "./Cash.vue?vue&type=script&lang=ts"
export * from "./Cash.vue?vue&type=script&lang=ts"

import "./Cash.vue?vue&type=style&index=0&id=131e5bf4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131e5bf4"]])

export default __exports__